import { createTheme } from '@mui/material/styles';
import type { ThemeOptions } from '@mui/material/styles';

// Legacy FancyHands colors
const colors = {
  primary: '#1C90D9',
  primaryLight: '#20C0DE',
  primaryDark: '#1977B2',
  secondary: '#11a5ae',
  success: '#56c98d',
  error: '#db5344',
  warning: '#eac11c',
};

const baseTheme: ThemeOptions = {
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontSize: '2.5rem', fontWeight: 500 },
    h2: { fontSize: '2rem', fontWeight: 500 },
    h3: { fontSize: '1.75rem', fontWeight: 500 },
    h4: { fontSize: '1.5rem', fontWeight: 500 },
    h5: { fontSize: '1.25rem', fontWeight: 500 },
    h6: { fontSize: '1rem', fontWeight: 500 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', borderRadius: 8 },
        contained: { boxShadow: '0 2px 0 rgba(0,0,0,0.1)' },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.12)',
        },
      },
    },
    MuiTextField: {
      defaultProps: { variant: 'outlined', size: 'small' },
    },
  },
};

export const lightTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: 'light',
    primary: { main: colors.primary, light: colors.primaryLight, dark: colors.primaryDark },
    secondary: { main: colors.secondary },
    success: { main: colors.success },
    error: { main: colors.error },
    warning: { main: colors.warning, contrastText: '#000000' },
    info: { main: '#2196f3' },
    background: { default: '#F4F4F4', paper: '#FFFFFF' },
    text: { primary: '#393939', secondary: '#6A6A6A' },
  },
  components: {
    ...baseTheme.components,
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundImage: 'radial-gradient(ellipse at 90% 10%, rgba(28, 144, 217, 0.06) 0%, transparent 50%)',
          backgroundAttachment: 'fixed',
        },
      },
    },
  },
});

export const darkTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: 'dark',
    primary: { main: colors.primaryLight, light: '#64b5f6', dark: colors.primary },
    secondary: { main: colors.secondary },
    success: { main: colors.success },
    error: { main: colors.error },
    warning: { main: colors.warning, contrastText: '#000000' },
    info: { main: '#64b5f6' },
    background: { default: '#343539', paper: '#38363D' },
    text: { primary: '#FAFAFA', secondary: '#B8B8B8' },
  },
  components: {
    ...baseTheme.components,
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 1px 3px rgba(0,0,0,0.3), 0 1px 2px rgba(0,0,0,0.24)',
          border: '1px solid #444',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundImage: 'radial-gradient(ellipse at 90% 10%, rgba(32, 192, 222, 0.08) 0%, transparent 50%)',
          backgroundAttachment: 'fixed',
        },
      },
    },
  },
});

// Keep backward compat export
export const theme = lightTheme;
